import styled from '@emotion/styled';
import { IonModal, IonThumbnail, isPlatform, IonIcon } from '@ionic/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Zoom } from 'swiper/modules';

import { chevronBackOutline } from 'ionicons/icons';
import React from 'react';

import 'swiper/css/zoom';

const Modal = styled(IonModal)`
  --background: rgba(0, 0, 0, 0.75);
`;

type ImageModalProps = {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  modalImage: string;
};

export const ImageModal: React.FC<ImageModalProps> = ({
  showModal,
  setShowModal,
  modalImage,
}) => {
  return (
    <Modal
      isOpen={showModal}
      onDidDismiss={() => {
        setShowModal(false);
      }}
    >
      <IonIcon
        color="light"
        icon={chevronBackOutline}
        onClick={() => {
          setShowModal(false);
        }}
        size="large"
        style={{
          padding: '15px 10px',
          marginTop: isPlatform('ios') ? '30px' : 'auto',
        }}
      />
      <Swiper
        modules={[Zoom]}
        zoom={{
          maxRatio: 5,
        }}
        style={{
          height: '100%',
          width: '100%',
        }}
      >
        <SwiperSlide>
          <div className="swiper-zoom-container">
            <IonThumbnail
              className="swiper-zoom-target"
              style={
                {
                  backgroundImage: modalImage,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  '--size': '100%',
                } as React.CSSProperties
              }
            />
          </div>
        </SwiperSlide>
      </Swiper>
    </Modal>
  );
};
